import Head from "next/head";
import React from "react";

import Data from "components/data/Data/Data";
import TabsMenu from "components/global/TabsMenu/TabsMenu";
import CONSTANTS from "config/constants";
import useI18n from "hooks/useI18n";

const { TITLE } = CONSTANTS;

interface Props {}

const DataPage = (props: Props) => {
  const t = useI18n();

  return (
    <>
      <Head>
        <title>
          {t.terms.data} | {TITLE}
        </title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <Data />
      </TabsMenu>
    </>
  );
};

export default DataPage;
